import connect from '../../../../../helpers/api/connect'
import CalculationPosition from '../../../../../types/api/calculation-position'
import Shipment from '../../../../../types/api/shipment'
import { StrapiCreate } from '../../../../../types/strapi/strapi'

type CreateShipmentData = Exclude<StrapiCreate<Shipment>['data'], undefined>

type ShipmentStampFields = Pick<
    CreateShipmentData,
    'withoutCutting' | 'stamp' | 'virtualStamp' | 'stampFloods'
>

export function buildShipmentStampFieldsFromCalcPos(
    calcPos: CalculationPosition
): ShipmentStampFields {
    if (calcPos.withoutCutting) {
        const virtualStamp = calcPos.virtualStamp

        return {
            withoutCutting: true,
            virtualStamp: virtualStamp
                ? {
                      width: virtualStamp.width,
                      length: virtualStamp.length,
                      floods: virtualStamp.floods,
                      range: virtualStamp.range,
                      roller: virtualStamp.roller?.documentId
                          ? { set: [virtualStamp.roller.documentId] }
                          : undefined,
                  }
                : undefined,
        }
    }

    return {
        withoutCutting: false,
        stamp: calcPos.stamp ? connect(calcPos.stamp) : undefined,
        stampFloods: calcPos.stampFloods,
    }
}
